module.exports = __webpack_public_path__ + "img/75669.68a42364.svg";